'use client';

import { Divider } from '@wolfejs/ui/Divider';
import type { MainMenuItemRecursive, MenuItemRecursive } from '@wolfejs/ui/Menu';
import { Menu, MenuItem } from '@wolfejs/ui/Menu';
import type { UIComponentProps } from '@wolfejs/ui/types/UI';
import { UIShapes, UIVariants } from '@wolfejs/ui/types/UI';
import { cn } from '@wolfejs/ui/utils/classnames';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

export type SideAppNavProps = UIComponentProps & {
  slug?: string;
  fixedPosition?: boolean;
  rightBorder?: boolean;
  menuItems: MenuItemRecursive[];
  helperMenuItems?: MenuItemRecursive[];
  handleNavClick?: (item?: MenuItemRecursive) => void;
};
export const AppNav = ({
  className,
  menuItems,
  slug,
  fixedPosition,
  helperMenuItems,
  rightBorder,
  handleNavClick,
}: SideAppNavProps) => {
  const pathname = usePathname();
  const getPathname = (item: MainMenuItemRecursive) => {
    if (item.text === 'Help') {
      return `mailto:${item.url}`;
    }
    return slug ? `/${slug}${item.url}` : item.url;
  };

  return (
    <div
      className={cn(
        'dark:bg-default-900 border-default-400 gap-6 overflow-y-auto  bg-white',
        {
          'fixed top-16 w-64': fixedPosition,
          'border-r': rightBorder,
        },
        className
      )}
      style={fixedPosition ? { height: 'calc(100vh - 64px)' } : {}}
    >
      <Menu
        variant={UIVariants.ghost}
        items={menuItems}
        onClick={handleNavClick}
        className={cn('flex h-full w-full flex-col')}
        classNames={{
          box: cn('bg-white dark:bg-default-900 text-foreground dark:text-default-foreground w-full border-none'),
          item: cn(''),
        }}
        renderItem={(item: MainMenuItemRecursive) => {
          return (
            <Link
              href={getPathname(item) || ''}
              target={item.text === 'Help' ? '_blank' : '_self'}
              className={cn('text-foreground')}
            >
              <MenuItem
                shape={UIShapes.rect}
                item={item}
                isActive={
                  getPathname(item) === `/${slug}/`
                    ? pathname === `/${slug}`
                    : '/' + pathname.split('/')[1] === (item.url as string)
                }
                className={cn('p-2')}
              />
            </Link>
          );
        }}
      />
      {helperMenuItems && (
        <>
          <Divider />
          <AppNav menuItems={helperMenuItems} slug={slug} handleNavClick={handleNavClick} />
        </>
      )}
    </div>
  );
};
